import {resolveMockOperation} from './resolvers';

export const MOCK_ENDPOINT = 'mock://pgServer';

let installed = false;

function extractOperationField(query: string): string | null {
    // queries/mutations in this codebase are always shaped as
    // `query/mutation Name(...) { <field>(...) { ... } }` — the field we
    // dispatch on is the first identifier after the operation's outer `{`.
    const match = query.match(/\b(?:query|mutation)\b[^{]*\{\s*([A-Za-z_][A-Za-z0-9_]*)/);
    return match ? match[1] : null;
}

export function installMockFetch(): void {
    if (installed) {
        return;
    }
    installed = true;

    const realFetch = window.fetch.bind(window);

    window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

        if (!url.startsWith(MOCK_ENDPOINT)) {
            return realFetch(input, init);
        }

        try {
            const {query, variables} = JSON.parse(String(init?.body ?? '{}'));
            const field = extractOperationField(String(query ?? ''));

            if (!field) {
                throw new Error(`mock-backend: could not parse GraphQL operation field from query`);
            }

            const data = resolveMockOperation(field, variables ?? {});
            return new Response(JSON.stringify({data: {[field]: data}}), {
                status: 200,
                headers: {'Content-Type': 'application/json'},
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            return new Response(JSON.stringify({errors: [{message}]}), {
                status: 200,
                headers: {'Content-Type': 'application/json'},
            });
        }
    };
}
